/*eslint-disable*/
import moment from "moment";
import React, { useState, useEffect } from "react";
// import MultiSelect from 'react-multi-select-component';
import { Dropdown } from "semantic-ui-react";
import AxiosRequest from "../axiosComponent/allAxiosCommonRequest";
//import { GetCommonBaseURL } from '../axiosComponent/read';

const MyCustomerType = ({
  field: { name },
  form: { setFieldValue },
  ...props
}) => {
  const [content, setcontent] = useState([]);
  const [loading, setloading] = useState(false);
  useEffect(() => {
    setloading(true);
    if (props.multiSelect) {
      AxiosRequest({
        url: "masters/billing_party_types",
        method: "get",
        getValues: false,
      }).then((response) => {
        if (response.data.resultSet.length > 0) {
          // let inObjects = Object.assign({}, response.data.resultSet)
          // // console.log('>>', response.data.resultSet.toString(), inObjects)
          setcontent(response.data.resultSet);
          setloading(false);
        }
      });
    } else {
      AxiosRequest({
        url: "masters/billingPartyPaymentType",
        method: "get",
      }) //CommonGetApi({ url: 'branch' })
        .then((data) => {
          let cont = data.data.resultSet;
          // console.log(cont)
          setcontent(cont);
          setloading(false);
        })
        .catch((error) => console.log(error));
      /* GetCommonBaseURL({
                newUrl: 'masters/billingPartyPaymentType',
                response: ((data) => {
                    let cont = data.data.resultSet
                    // console.log(cont)
                    setcontent(cont)
                    setloading(false)
                })
            }) */
    }
  }, []);
  let options = [];
  if (content.length > 0) {
    content.map((object, index) => {
      let temp = {};
      if (props.multiSelect) {
        temp.key = `${object}`.replace(/([A-Z]+)/g, " $1");
        temp.text = `${object}`.replace(/([A-Z]+)/g, " $1");
        temp.value = object;
        return (options[index] = temp);
      } else {
        temp.key = object.billingPartyPaymentTypeId;
        temp.text = `${object.billingPartyPaymentTypeName}`;
        temp.value = props.lrMode
          ? object.billingPartyPaymentTypeName
          : object.billingPartyPaymentTypeId;
        return (options[index] = temp);
      }
    });
  }
  let handleChange = (value, data) => {
    setFieldValue(name, data.value);
    if (props.mode == "edit") {
      // console.log(data.value)
      let content = [];
      let date = new Date();
      Date.prototype.addDays = function (n) {
        var time = this.getTime();
        var changedDate = new Date(time + n * 24 * 60 * 60 * 1000);
        this.setTime(changedDate.getTime());
        return this;
      };
      data.value.map((element) => {
        content[element] = 1;
        content["billingPartyId"] = props.editId;
        content["tbbStartDate"] = moment().format("YYYY-MM-DD HH:mm:ss");
        content["tbbEndDate"] = moment(date.addDays(+30)).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      });
      // console.log(content)
      AxiosRequest({
        url: "masters/billing_party_type_mapping",
        method: "PUT",
        Items: content,
      })
        .then((response) => {
          // console.log(response)
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  return (
    <>
      <Dropdown
        selection
        loading={loading ? true : false}
        style={{ width: "100%" }}
        onChange={handleChange}
        options={options}
        // id="searchType"
        noResultsMessage="Search for Result"
        {...props}
      />
    </>
  );
};

export default MyCustomerType;
